<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 4H5.5C4.67157 4 4 4.67157 4 5.5V14.5C4 15.3284 4.67157 16 5.5 16H14.5C15.3284 16 16 15.3284 16 14.5V5.5C16 4.67157 15.3284 4 14.5 4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 8.125H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 11.875H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.1875 9.0625C7.70527 9.0625 8.125 8.64277 8.125 8.125C8.125 7.60723 7.70527 7.1875 7.1875 7.1875C6.66973 7.1875 6.25 7.60723 6.25 8.125C6.25 8.64277 6.66973 9.0625 7.1875 9.0625Z" fill="currentColor"/>
    <path d="M7.1875 12.8125C7.70527 12.8125 8.125 12.3928 8.125 11.875C8.125 11.3572 7.70527 10.9375 7.1875 10.9375C6.66973 10.9375 6.25 11.3572 6.25 11.875C6.25 12.3928 6.66973 12.8125 7.1875 12.8125Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'DiscoveryBrandsIcon'
}
</script>

